import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/content";

const inputCls = "rounded-lg border border-gold/20 bg-espresso px-3 py-2 text-sm text-cream outline-none focus:border-gold";

export const AdminUsers = ({ me, errMsg }) => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", password: "", role: "editor" });

  const load = useCallback(async () => {
    const r = await axios.get(`${API}/users`, { withCredentials: true });
    setUsers(Array.isArray(r.data) ? r.data : []);
  }, []);
  useEffect(() => {
    load().catch(() => {});
  }, [load]);

  const create = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/users`, form, { withCredentials: true });
      setForm({ email: "", name: "", password: "", role: "editor" });
      toast.success("Cuenta creada");
      load();
    } catch (x) {
      toast.error(errMsg(x));
    }
  };
  const remove = async (u) => {
    if (!window.confirm(`¿Eliminar la cuenta de ${u.email}?`)) return;
    try {
      await axios.delete(`${API}/users/${u.id}`, { withCredentials: true });
      load();
    } catch (x) {
      toast.error(errMsg(x));
    }
  };
  const changePwd = async (u) => {
    const p = window.prompt(`Nueva contraseña para ${u.email} (mínimo 8 caracteres):`);
    if (!p) return;
    try {
      await axios.put(`${API}/users/${u.id}/password`, { password: p }, { withCredentials: true });
      toast.success("Contraseña actualizada");
    } catch (x) {
      toast.error(errMsg(x));
    }
  };

  return (
    <div className="space-y-8">
      <form onSubmit={create} data-testid="admin-user-form" className="grid gap-3 rounded-2xl border border-gold/15 p-5 md:grid-cols-5">
        <input data-testid="admin-user-email" type="email" required placeholder="Correo" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} />
        <input data-testid="admin-user-name" placeholder="Nombre" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inputCls} />
        <input data-testid="admin-user-password" required minLength={8} placeholder="Contraseña (8+)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} />
        <select data-testid="admin-user-role" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className={inputCls}>
          <option value="editor">Editor (solo edita contenido)</option>
          <option value="admin">Administrador (también cuentas)</option>
        </select>
        <button data-testid="admin-user-create" className="rounded-full bg-gold px-4 py-2 text-sm font-semibold text-espresso">Crear cuenta</button>
      </form>
      <ul className="divide-y divide-gold/10 rounded-2xl border border-gold/15">
        {users.map((u) => (
          <li key={u.id} data-testid={`admin-user-row-${u.email}`} className="flex flex-wrap items-center gap-3 px-5 py-3 text-sm">
            <span className="text-cream">{u.email}</span>
            <span className="text-sand">{u.name}</span>
            <span className="rounded-full border border-gold/30 px-2 py-0.5 text-xs text-gold">{u.role === "admin" ? "Administrador" : "Editor"}</span>
            <div className="ml-auto flex gap-3">
              <button onClick={() => changePwd(u)} className="text-xs text-sand hover:text-cream">Cambiar contraseña</button>
              {u.id !== me.id && <button data-testid={`admin-user-delete-${u.email}`} onClick={() => remove(u)} className="text-xs text-red-300">Eliminar</button>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
